import { useContext } from 'react';

import { Navigate } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MY_CARDS_VAULT_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MyCardsLayoutContext } from '#src/layouts/my-cards/MyCardsLayout/MyCardsLayoutContext.tsx';

const MyCardsVaultPage = () => {
  const { defaultRarity } = useContext(MyCardsLayoutContext);
  const { generateSportContextPath } = useSportContext();

  const rarity =
    defaultRarity !== Rarity.common ? defaultRarity : Rarity.limited;
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_VAULT_TYPE, {
        params: {
          type: rarity,
        },
      })}
    />
  );
};

export default MyCardsVaultPage;
